<template>
  <div id="app">
    <el-container>
      <el-header>
        <index-header />
      </el-header>
      <el-container>
        <el-aside width="250px">
          <index-aside />
        </el-aside>
        <el-container class="main-wrap">
          <el-main>
            <router-view />
          </el-main>
          <el-footer>
            <p>Copyright ©2017 - 2019 www.hbchanyelian.com All Rights Reserved 版权所有 ICP备案号：冀ICP备18005755号</p>
            <p>邮箱：zlqt@163.com 服务热线：0311-66567128</p>
          </el-footer>
        </el-container>
      </el-container>
    </el-container>
  </div>
</template>

<script>
  import indexHeader from '@/components/wrap/Head'
  import indexAside from '@/components/wrap/Asid'
  export default {
    name: 'App',
    data() {
      return {}
    },
    methods: {

    },
    components: {
      indexHeader,
      indexAside
    }
  }
</script>

<style scoped>
  .el-header {
    background: #545c64;
  }

  .el-col {
    height: 60px;
    line-height: 60px;
    text-align: center;
  }

  .logo img {
    vertical-align: middle;
  }

  .sign-out {
    color: #F56C6C;
  }

  #app {
    height: 100%;
	height: 93vh;
  }

  .el-container {
    height: 100%;
  }

  .el-menu {
    height: 100%;
  }

  .el-footer {
	  height: 20px !important;
    margin: 15px 0;
    text-align: center;
    font-size: 12px;
  }

  .el-aside {
    width: 200px;
  }
</style>
<style>
  * {
    margin: 0;
    padding: 0;
  }

  html,
  body {
    height: 100%;
  }

  .el-breadcrumb {
    margin: 20px 0;
  }

  .el-pagination {
    margin: 20px 0;
    text-align: center;
  }

  .nullImg {
    text-align: center;
  }

  .nullImg img {
    width: 500px;
    height: 500px;
  }

  .el-row {
    min-width: 800px;
  }

  .el-main {
    padding: 0;
  }

  .wrap {
    min-width: 1200px;
    min-height: 100%;
    padding: 20px;
  }

  .remind-wrap {
    margin: 15px 0 19px;
  }

  .remind {
    height: 30px;
    border: 1px solid #f1dfd3;
    display: flex;
    color: #e3393b;
    align-items: center;
    padding: 0 13px;
    margin: 15px 0 19px;
    background: #fefced;
  }

  .remind:before {
    content: '';
    width: 18px;
    height: 18px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpBQzY4NUVBQTJFMDUxMUVBOEVGMEI1Q0FCN0Q2RjkxNSIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpBQzY4NUVBQjJFMDUxMUVBOEVGMEI1Q0FCN0Q2RjkxNSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkFDNjg1RUE4MkUwNTExRUE4RUYwQjVDQUI3RDZGOTE1IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkFDNjg1RUE5MkUwNTExRUE4RUYwQjVDQUI3RDZGOTE1Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+zUWhIQAAAXZJREFUeNqElF0rBHEUxnfG2JSifADZC2+5sHJFKS+bFuGOCzekuCLfRFxSPoC9QbJSXiIusSW54nOs3R2eR89omubMnPo1u/9z5pz/eRunWu7KGNIPFkEBeOAOnIAK+AmMssWvv6cb42BUhu9gBjzJCc9fgA+moy95kf/7YAssgPNw5JCMgXtwAebiHO3JSQuoZmx5AM2gBsq69X9qI2CbKcc4YdS1yFld7xa/L3MrPHBUbKawBEoxNzgDedAZoxsEr3TK1Pp0WDJSYdEbhq6iZ5HXW1XxksRP0B2CDToaB1cpjtwE3S0YcNW5eoJhk0i6rUtHj2AywbBbxbaEg/rBrg3hxzM7aBh60tUMPc+XXY09ZcIwbAMdhi6nQKdBEWfBjVFUDuqu4eiTeixuwwltPwdvXoX1U7rIVN+4KnDSE20rF/Vaw5dPKT4DtYJea/sLWpWgbkfqKldoGKxrqTfBQdqgHSu9KUXmF2EHtCtINuqE8ivAAOB5T03fN9nYAAAAAElFTkSuQmCC);
  }

  .remind p {
    margin-left: 4px;
    margin-right: auto;
  }

  .remind a {
    color: #065ea5;
    text-decoration: underline;
  }

  .remind i {
    width: 11px;
    height: 11px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo2M0UxMTIwODJFMDYxMUVBQjU5NjkwNkM3ODJDQjA0NyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo2M0UxMTIwOTJFMDYxMUVBQjU5NjkwNkM3ODJDQjA0NyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjYzRTExMjA2MkUwNjExRUFCNTk2OTA2Qzc4MkNCMDQ3IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjYzRTExMjA3MkUwNjExRUFCNTk2OTA2Qzc4MkNCMDQ3Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+VO7huAAAANtJREFUeNpinDlz5n8GBoZ5aWlpyQw4wKxZs0DUbCYgIQbESUCBBgbc4CIQpzABTXwNZAgCcT1QQyUWUw8DKT0gZgWZzADU8AFI8QFxG1CyFUnhHiBlA8QsQDV/GP///49sigCQeg/EgUCsAcTtUIV/QfIoiqEauIHUFyiXEagQLseExTO1QHwSiJ8DcSKyBLozDkPdyAjEbED8E4grgaZ3oJgMVLgLqpAVZDUQ/wKy+UHuBsrVwE2G+toZ2TNYPN3JLCUl9QwajhgKQcDY2PjH2bNnpwOZGwACDAAoAFXgiU38qAAAAABJRU5ErkJggg==);
  }
</style>



// WEBPACK FOOTER //
// src/App.vue